import dynamic from "next/dynamic";
import SideBySideHeroConfig from "./side-by-side-hero-config";
const SideBySideHeroComponent = dynamic(()=>import("./side-by-side-hero-component"));
export default {
    SideBySideHeroComponent,
    SideBySideHeroConfig
};
